export default "__VITE_ASSET__c3b6676a__"